import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '@shared/ui/modal';
import { ConfirmationService } from 'primeng/api';
import { Observable, from } from 'rxjs';
import { NotificationService } from '@shared/feature/notification-handling';
import { IconType } from '@shared/utils/icons';
import { TranslationFromJsonService } from '@shared/feature/translate';

@Injectable({ providedIn: 'root' })
export class ModalService {
  constructor(
    private ngbModal: NgbModal,
    public confirmationService: ConfirmationService,
    private notification: NotificationService,
    private translationService: TranslationFromJsonService
  ) {}

  openConfirmModal(title: string, body: string): Observable<boolean> {
    const modalInstance = this.ngbModal.open(ConfirmModalComponent);
    modalInstance.componentInstance.title = title;
    modalInstance.componentInstance.body = body;

    return from(
      modalInstance.result.then(
        () => true,
        () => false
      )
    );
  }

  openConfirmationDialog(header: string, message: string, notificationMessage?: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.confirmationService.confirm({
        header: header,
        message: message,
        icon: IconType.ExclamationTriangle,
        acceptLabel: this.translationService.instant('button-yes'),
        rejectLabel: this.translationService.instant('button-cancel'),
        acceptButtonStyleClass: 'p-button-danger p-button-sm px-3',
        rejectButtonStyleClass: 'p-button-secondary p-button-sm',
        accept: () => {
          observer.next(true);
          observer.complete();
          if (notificationMessage != null) {
            this.notification.addSuccess(notificationMessage);
          }
        },
        reject: () => {
          observer.next(false);
          observer.complete();
        },
        key: 'globalConfirmDialog',
      });

      return () => {
        this.confirmationService.close();
      };
    });
  }

  closeAllModals(): void {
    this.ngbModal.dismissAll();
  }
}
